// base
import { createSlice } from '@reduxjs/toolkit';
import { NATION_SLICE_NAME } from '../actions/nation.action';

// thunks
import { createNation, deleteNation, getNations, updateNation } from '../thunks/nation.thunk';
import { INation, IOption } from '../models/nation.model';

export interface NationState {
  nations: INation[];
  nationOptions: IOption[];
}

// initialState
const initialState: NationState = {
  nations: [],
  nationOptions: []
};

// createSlice
const nationSlice = createSlice({
  name: NATION_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNations.fulfilled, (state, action) => {
        const nations = action.payload.resultList;

        state.nations = nations;
        state.nationOptions = nations.map((nation) => ({
          label: nation.countryName,
          value: nation.nationId
        }));
      })

      .addCase(createNation.fulfilled, (state, action) => {})

      .addCase(updateNation.fulfilled, (state, action) => {})

      .addCase(deleteNation.fulfilled, (state, action) => {});
  }
});

export const nation = nationSlice.name;
export const nationReducer = nationSlice.reducer;
export const nationActions = nationSlice.actions;
export default nationSlice.reducer;
